import { Component, Input, OnInit } from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { AppService } from 'src/app/core/services/app.service';
import { LocalStorageService } from 'ngx-webstorage';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-send-bulk-email',
  templateUrl: './send-bulk-email.component.html',
  styleUrls: ['./send-bulk-email.component.css']
})
export class SendBulkEmailComponent implements OnInit {
  @Input() agent;
  listAgent: any = [];
  selectedAgent: any;
  settingsAgent = {};
  emailContent: any;
  response: any;
  listTypeCourrier: any = [];
  id_type_courrier: any;
  reference: string;
  editorConfig: AngularEditorConfig = {
    editable: true,
      spellcheck: true,
      height: '230px',
      minHeight: '0',
      maxHeight: '230px',
      width: 'auto',
      minWidth: '0',
      translate: 'yes',
      enableToolbar: true,
      showToolbar: true,
      defaultParagraphSeparator: '',
      defaultFontName: '',
      defaultFontSize: '',
      fonts: [
        {class: 'arial', name: 'Arial'},
        {class: 'times-new-roman', name: 'Times New Roman'},
        {class: 'calibri', name: 'Calibri'},
        {class: 'comic-sans-ms', name: 'Comic Sans MS'}
      ]
};
  constructor(private activeModal: NgbActiveModal, private loadingBar: LoadingBarService,
    private _service: AppService, private storage: LocalStorageService, private toastrService: ToastrService) { }

  ngOnInit() {
    this.settingsAgent = {
      singleSelection: false,
      text: 'Sélectionner les agents',
      selectAllText: 'Tout sélectionner',
      unSelectAllText: 'Tout déselectionner',
      classes: 'myclass custom-class',
      labelKey: 'nom_prenoms',
      enableSearchFilter: true,
      searchBy: ['nom_prenoms'],
      searchPlaceholderText: 'Rechercher',
      noDataLabel: 'Aucun agent disponible'
    };
    this.agent.forEach(element => {
      element.nom_prenoms = element.nom + ' ' + element.prenoms;
    });
    this.getAllTypeCourrier();
  }

  closeModal() {
    this.activeModal.close();
  }

    // Get all typeCourrier
    getAllTypeCourrier() {
      this.loadingBar.start();
        this._service.getData('campagne/type_courriers/all').subscribe((data: {}) => {
        this.loadingBar.stop();
        this.response = data;
        this.listTypeCourrier = this.response.data;
      });
    }
  
    onSelectTypeCourrier(data) {
      this.id_type_courrier = data;
    }

    sendBulkEmail() {
      this.loadingBar.start();
      const data = {
        'campagne_ofa_id': this.storage.retrieve('idCampagneOfaSelected'),
        'agents': this.selectedAgent,
        'corps': this.emailContent,
        'type_courrier_id': this.id_type_courrier,
        'reference' : this.reference
      }
        this._service.postData('campagne/ofa/send_en_masse_email_decision_final', data).subscribe((data: {}) => {
        this.loadingBar.stop();
          this.response = data;
          if (!this.response.error) {
            this.toastrService.success(this.response.message);
            this.activeModal.close();
          } else {
            this.toastrService.error(this.response.message);
          }
      });
    }

}
